document.addEventListener('DOMContentLoaded', function () {
  const menuIcon = document.getElementById('mobile-menu');
  const menuButton = document.getElementById('mobile-button');
  if (!menuIcon || !menuButton) return;
  menuButton.addEventListener('click', function () {
    menuIcon.classList.toggle('hidden');
  });
});

// Video Modal functionality
document.addEventListener('DOMContentLoaded', function () {
  const playButton = document.getElementById('video-play-button');
  const modal = document.getElementById('video-modal');
  const closeButton = document.getElementById('video-modal-close');
  const videoContainer = document.getElementById('video-container');

  if (!playButton || !modal) return;

  const videoId = modal.dataset.videoId;

  function openModal() {
    // Insert YouTube iframe with autoplay
    videoContainer.innerHTML = `
      <iframe
        src="https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0"
        class="w-full h-full"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    `;
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.add('hidden');
    videoContainer.innerHTML = '';
    document.body.style.overflow = '';
  }

  playButton.addEventListener('click', openModal);

  closeButton.addEventListener('click', closeModal);

  // Close on backdrop click
  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
      closeModal();
    }
  });
});

// Onboarding Tour — supports parent profile (#parent-profile-page) and child dashboard (#child-dashboard)
document.addEventListener('DOMContentLoaded', function () {
  // Detect which tour page we're on
  var isParentTour = !!document.getElementById('parent-profile-page');
  var isChildTour = !!document.getElementById('child-dashboard');
  if (!isParentTour && !isChildTour) return;

  var tourType = isParentTour ? 'parent' : 'child';
  var storageKey = 'tyb_tour_' + tourType + '_completed';

  // Fast localStorage check to avoid flicker (server-side rendering handles the definitive check)
  if (localStorage.getItem(storageKey)) return;

  // Gather steps from data-tour-step attributes
  var steps = [];
  for (var i = 1; i <= 10; i++) {
    var el = document.querySelector('[data-tour-step="' + i + '"]');
    if (el) steps.push({ element: el, text: el.dataset.tourText });
  }
  if (steps.length === 0) return;

  var currentStep = 0;

  // Create backdrop overlay
  var backdrop = document.createElement('div');
  backdrop.id = 'tour-backdrop';
  backdrop.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9998;transition:opacity 0.2s;';

  // Create tooltip element
  var tooltip = document.createElement('div');
  tooltip.id = 'tour-tooltip';
  tooltip.style.cssText = 'position:absolute;z-index:10000;background:white;border-radius:16px;padding:16px 20px;max-width:300px;box-shadow:0 10px 40px rgba(0,0,0,0.3);';

  function showStep(index) {
    var step = steps[index];
    var rect = step.element.getBoundingClientRect();

    // Highlight the target element
    step.element.style.position = step.element.style.position || 'relative';
    step.element.style.zIndex = '9999';

    // Position tooltip below the element
    var top = rect.bottom + window.scrollY + 12;
    var left = rect.left + window.scrollX + (rect.width / 2) - 150;
    left = Math.max(12, Math.min(left, window.innerWidth - 312));

    tooltip.style.top = top + 'px';
    tooltip.style.left = left + 'px';

    var stepNum = index + 1;
    var totalSteps = steps.length;
    var isLast = index === steps.length - 1;

    // Determine last-step button text
    var nextLabel;
    if (isLast && isParentTour) {
      nextLabel = "See Your Child's View";
    } else if (isLast) {
      nextLabel = 'Got it!';
    } else {
      nextLabel = 'Next (' + stepNum + '/' + totalSteps + ')';
    }

    tooltip.innerHTML =
      '<p style="color:#374151;font-size:14px;line-height:1.5;margin:0 0 12px 0;">' + step.text + '</p>' +
      '<div style="display:flex;align-items:center;justify-content:space-between;">' +
        '<button id="tour-skip" style="color:#9CA3AF;font-size:13px;background:none;border:none;cursor:pointer;padding:4px 0;">Skip</button>' +
        '<button id="tour-next" style="background:linear-gradient(135deg,#4F46E5,#9333EA);color:white;border:none;border-radius:10px;padding:8px 18px;font-size:13px;font-weight:600;cursor:pointer;">' +
          nextLabel +
        '</button>' +
      '</div>';

    // Scroll into view
    step.element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearHighlight(index) {
    if (steps[index]) {
      steps[index].element.style.zIndex = '';
    }
  }

  function persistTourComplete() {
    localStorage.setItem(storageKey, 'true');
    var csrfMeta = document.querySelector('[name="csrf-token"]');
    if (csrfMeta) {
      fetch('/users/complete_tour', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfMeta.content
        },
        body: JSON.stringify({ tour_type: tourType })
      }).catch(function () { /* silent — localStorage already set */ });
    }
  }

  function removeTourUI() {
    clearHighlight(currentStep);
    if (backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
    if (tooltip.parentNode) tooltip.parentNode.removeChild(tooltip);
  }

  function endTour() {
    persistTourComplete();
    removeTourUI();
  }

  function advance() {
    clearHighlight(currentStep);
    currentStep++;
    if (currentStep >= steps.length) {
      // Tour finished
      persistTourComplete();
      removeTourUI();

      // Parent tour: submit the impersonation form to switch to child view
      if (isParentTour) {
        var impersonateBtn = document.querySelector('#impersonate-form');
        var form = impersonateBtn && (impersonateBtn.closest('form') || impersonateBtn.form);
        if (form) form.submit();
      }
    } else {
      showStep(currentStep);
    }
  }

  // Event delegation for tooltip buttons
  document.addEventListener('click', function (e) {
    if (e.target && e.target.id === 'tour-next') advance();
    if (e.target && e.target.id === 'tour-skip') endTour();
  });

  // Start the tour
  document.body.appendChild(backdrop);
  document.body.appendChild(tooltip);
  showStep(0);
});